import { useSelector } from "react-redux"


const NewMeComponent = ({ children, showNewme }) => {
  return showNewme ? children : null

}

export default NewMeComponent
